export const moduleTypes = {
  ClinicalNote: {
    id: 1,
    title: 'Clinical Note',
  },
  QuickNote: {
    id: 2,
    title: 'Progress Note - General',
  },
  MonthlyCall: {
    id: 3,
    title: 'Progress Note - Monthly Call',
  },
  CallUnanswered: {
    id: 4,
    title: 'Call Unanswered',
  },
  Hypoglycemia: {
    id: 5,
    title: 'Hypoglycemia (Low Blood Glucose)',
  },
  Hyperglycemia: {
    id: 6,
    title: 'Hyperglycemia (High Blood Glucose)',
  },
  LowEngagement: {
    id: 7,
    title: 'Progress Note - Low Engagement',
  },
  TechnicalSupport: {
    id: 8,
    title: 'Technical Support',
  },
  Onboarding: {
    id: 9,
    title: 'Intake',
  },
  RPMStartOrder: {
    id: 10,
    title: 'RPM Start Order',
  },
  PreAppointment: {
    id: 11,
    title: 'Pre-Appointment',
  },
  ClinicalIntake: {
    id: 12,
    title: 'Clinical Initial Visit',
  },
  HoldRequest: {
    id: 13,
    title: 'Hold Request',
  },
  HyperglycemicTrend: {
    id: 14,
    title: 'Hyperglycemic Trend',
  },
  PhysicianNote: {
    id: 15,
    title: 'Physician Note',
  },
  DeviceWalkthrough: {
    id: 16,
    title: 'Device Setup & Training',
  },
  EnrollmentNote: {
    id: 17,
    title: 'Enrollment Note',
  },
  Addendum: {
    id: 18,
    title: 'Addendum',
  },
  PatientRounds: {
    id: 19,
    title: 'Member Rounds',
  },
  NutritionConsult: {
    id: 20,
    title: 'Progress Note - Nutrition Assessment',
  },
  EducationDelivery: {
    id: 21,
    title: 'Progress Note - Education Delivery',
  },
  CloseDiabetesAccount: {
    id: 22,
    title: 'Close Diabetes Account Request',
  },
  NutritionFollowUp: {
    id: 23,
    title: 'Progress Note - Nutrition Follow Up',
  },
  CoachingCall: {
    id: 24,
    title: 'Coaching Call',
  },
  Diabetes101: {
    id: 25,
    title: 'Diabetes 101',
  },
  MedicationReconciliation: {
    id: 26,
    title: 'Medication Reconciliation',
  },
  MFARequest: {
    id: 27,
    title: 'MFA Request',
  },
  MFADecision: {
    id: 28,
    title: 'MFA Decision',
  },
  CommercialPlanReview: {
    id: 29,
    title: 'Commercial Plan Review',
  },
  SelfServeIntakeConfirmation: {
    id: 30,
    title: 'Self-Serve Intake - Confirmation',
  },
  SelfServeIntakeMedical: {
    id: 31,
    title: 'Self-Serve Intake - Medical',
  },
  SelfServeIntakeLifestyle: {
    id: 32,
    title: 'Self-Serve Intake - Lifestyle',
  },
  QuarterlyCheckIn: {
    id: 33,
    title: 'Progress Note - Quarterly Check In',
  },
  ClinicalFirstVisitNP: {
    id: 34,
    title: 'Clinical First Visit (NP)',
  },
  ClinicalFirstVisitRpmOrder: {
    id: 35,
    title: 'Clinical First Visit',
  },
  InitialCoachingCall: {
    id: 36,
    title: 'Initial Coaching Call',
  },
  MonthlyWellnessVisitAC: {
    id: 37,
    title: 'Progress Note - Monthly Wellness Visit',
  },
  CGMAssessment: {
    id: 38,
    title: 'CGM Assessment',
  },
  CGMQualificationExistingMembers: {
    id: 39,
    title: 'CGM Qualification - Established Patient',
  },
  MNTNote: {
    id: 40,
    title: 'Medical Nutrition Therapy (MNT)',
  },
  InformedConsentNote: {
    id: 41,
    title: 'Informed Consent Note',
  },
  CareCoordination: {
    id: 42,
    title: 'Care Coordination',
  },
  BiannualVisit: {
    id: 43,
    title: 'Biannual Patient Visit ',
  },
  ChartReview: {
    id: 44,
    title: 'Chart Review',
  },
  PerryHealthAssessment: {
    id: 45,
    title: 'Perry Health Assessment',
  },
  CoachIntroduction: {
    id: 46,
    title: 'Coach Introduction',
  },
  PerryMotivationQuestionnaire: {
    id: 47,
    title: 'Program Motivation Questionnaire',
  },
  PHQ9GAD7Assessment: {
    id: 48,
    title: 'PHQ-9 / GAD-7 Assessment',
  },
  CaseWorkAssessment: {
    id: 49,
    title: 'Case Work Assessment',
  },
  CaseWorkProgressNote: {
    id: 50,
    title: 'Case Work Progress Note',
  },
  MFARenewalRequest: {
    id: 51,
    title: 'MFA Renewal Request',
  },
  InsulinPumpAssessment: {
    id: 52,
    title: 'Insulin Pump Assessment',
  },
  CognitiveClinicalInterview: {
    id: 53,
    title: 'Cognitive Clinical Interview',
  },
  MemoryImpairmentScreen: {
    id: 54,
    title: 'Memory Impairment Screen',
  },
  ProviderEvaluationOfCognitiveScreening: {
    id: 55,
    title: 'Provider Evaluation of Cognitive Screening',
  },
  MoCABlind: {
    id: 56,
    title: 'MoCA-Blind',
  },
  MindyScreeningResult: {
    id: 57,
    title: 'Mindy Screening Result',
  },
  CloseCognitiveAccount: {
    id: 58,
    title: 'Close Cognitive Account Request',
  },
  MindyZBI22Assessment: {
    id: 59,
    title: 'ZBI-22 Assessment',
  },
  MindyPRO10Assessment: {
    id: 60,
    title: 'PRO-10 Assessment',
  },
  NeurologyEvaluation: {
    id: 61,
    title: 'Neurology Evaluation',
  },
  FAST: {
    id: 62,
    title: 'Functional Assessment Staging Tool (FAST)',
  },
  CarePlan: {
    id: 63,
    title: 'Care Plan',
  },
  GUIDEFirstCall: {
    id: 64,
    title: 'Initial Comprehensive Assessment',
  },
  GUIDEIntake: {
    id: 65,
    title: 'GUIDE Intake',
  },
  CrisisResponse: {
    id: 66,
    title: 'Crisis Response',
  },
  CognitiveCareIntake: {
    id: 67,
    title: 'Cognitive Care Intake',
  },
};

export const moduleTypePriority = {
  [moduleTypes.ClinicalNote.id]: 0,
  [moduleTypes.QuickNote.id]: 0,
  [moduleTypes.MonthlyCall.id]: 0,
  [moduleTypes.CallUnanswered.id]: 0,
  [moduleTypes.Hypoglycemia.id]: 0,
  [moduleTypes.Hyperglycemia.id]: 0,
  [moduleTypes.LowEngagement.id]: 0,
  [moduleTypes.TechnicalSupport.id]: 0,
  [moduleTypes.Onboarding.id]: 0,
  [moduleTypes.RPMStartOrder.id]: 0,
  [moduleTypes.PreAppointment.id]: 0,
  [moduleTypes.ClinicalIntake.id]: 0,
  [moduleTypes.HoldRequest.id]: 0,
  [moduleTypes.HyperglycemicTrend.id]: 0,
  [moduleTypes.PhysicianNote.id]: 0,
  [moduleTypes.DeviceWalkthrough.id]: 0,
  [moduleTypes.EnrollmentNote.id]: 0,
  [moduleTypes.Addendum.id]: 0,
  [moduleTypes.PatientRounds.id]: 0,
  [moduleTypes.NutritionConsult.id]: 0,
  [moduleTypes.EducationDelivery.id]: 0,
  [moduleTypes.CloseDiabetesAccount.id]: 0,
  [moduleTypes.NutritionFollowUp.id]: 0,
  [moduleTypes.CoachingCall.id]: 0,
  [moduleTypes.Diabetes101.id]: 0,
  [moduleTypes.MedicationReconciliation.id]: 0,
  [moduleTypes.MFARequest.id]: 0,
  [moduleTypes.MFADecision.id]: 0,
  [moduleTypes.CommercialPlanReview.id]: 0,
  [moduleTypes.SelfServeIntakeConfirmation.id]: 0,
  [moduleTypes.SelfServeIntakeMedical.id]: 0,
  [moduleTypes.SelfServeIntakeLifestyle.id]: 0,
  [moduleTypes.QuarterlyCheckIn.id]: 0,
  [moduleTypes.ClinicalFirstVisitNP.id]: 0,
  [moduleTypes.ClinicalFirstVisitRpmOrder.id]: 0,
  [moduleTypes.InitialCoachingCall.id]: 0,
  [moduleTypes.MonthlyWellnessVisitAC.id]: 0,
  [moduleTypes.CGMAssessment.id]: 0,
  [moduleTypes.CGMQualificationExistingMembers.id]: 0,
  [moduleTypes.MNTNote.id]: 0,
  [moduleTypes.InformedConsentNote.id]: 0,
  [moduleTypes.CareCoordination.id]: 1,
  [moduleTypes.BiannualVisit.id]: 0,
  [moduleTypes.ChartReview.id]: 0,
  [moduleTypes.PerryHealthAssessment.id]: 0,
  [moduleTypes.CoachIntroduction.id]: 0,
  [moduleTypes.PerryMotivationQuestionnaire.id]: 0,
  [moduleTypes.PHQ9GAD7Assessment.id]: 0,
  [moduleTypes.CaseWorkAssessment.id]: 0,
  [moduleTypes.CaseWorkProgressNote.id]: 0,
  [moduleTypes.MFARenewalRequest.id]: 0,
  [moduleTypes.InsulinPumpAssessment.id]: 0,
  [moduleTypes.CognitiveClinicalInterview.id]: 0,
  [moduleTypes.MemoryImpairmentScreen.id]: 0,
  [moduleTypes.ProviderEvaluationOfCognitiveScreening.id]: 0,
  [moduleTypes.MoCABlind.id]: 0,
  [moduleTypes.MindyScreeningResult.id]: 0,
  [moduleTypes.CloseCognitiveAccount.id]: 0,
  [moduleTypes.MindyZBI22Assessment.id]: 0,
  [moduleTypes.MindyPRO10Assessment.id]: 0,
  [moduleTypes.NeurologyEvaluation.id]: 0,
  [moduleTypes.FAST.id]: 0,
  [moduleTypes.CarePlan.id]: 0,
  [moduleTypes.GUIDEFirstCall.id]: 1,
  [moduleTypes.GUIDEIntake.id]: 0,
  [moduleTypes.CrisisResponse.id]: 0,
  [moduleTypes.CognitiveCareIntake.id]: 0,
};

export const sidebarModulesPriority = {
  [moduleTypes.ClinicalNote.id]: 0,
  [moduleTypes.QuickNote.id]: 0,
  [moduleTypes.MonthlyCall.id]: 0,
  [moduleTypes.CallUnanswered.id]: 0,
  [moduleTypes.Hypoglycemia.id]: 0,
  [moduleTypes.Hyperglycemia.id]: 0,
  [moduleTypes.LowEngagement.id]: 0,
  [moduleTypes.TechnicalSupport.id]: 0,
  [moduleTypes.Onboarding.id]: 0,
  [moduleTypes.RPMStartOrder.id]: 0,
  [moduleTypes.PreAppointment.id]: 0,
  [moduleTypes.ClinicalIntake.id]: 0,
  [moduleTypes.HoldRequest.id]: 0,
  [moduleTypes.HyperglycemicTrend.id]: 0,
  [moduleTypes.PhysicianNote.id]: 0,
  [moduleTypes.DeviceWalkthrough.id]: 0,
  [moduleTypes.EnrollmentNote.id]: 0,
  [moduleTypes.Addendum.id]: 0,
  [moduleTypes.PatientRounds.id]: 0,
  [moduleTypes.NutritionConsult.id]: 0,
  [moduleTypes.EducationDelivery.id]: 0,
  [moduleTypes.CloseDiabetesAccount.id]: 0,
  [moduleTypes.NutritionFollowUp.id]: 0,
  [moduleTypes.CoachingCall.id]: 0,
  [moduleTypes.Diabetes101.id]: 0,
  [moduleTypes.MedicationReconciliation.id]: 0,
  [moduleTypes.MFARequest.id]: 0,
  [moduleTypes.MFADecision.id]: 0,
  [moduleTypes.CommercialPlanReview.id]: 0,
  [moduleTypes.SelfServeIntakeConfirmation.id]: 0,
  [moduleTypes.SelfServeIntakeMedical.id]: 0,
  [moduleTypes.SelfServeIntakeLifestyle.id]: 0,
  [moduleTypes.QuarterlyCheckIn.id]: 0,
  [moduleTypes.ClinicalFirstVisitNP.id]: 0,
  [moduleTypes.ClinicalFirstVisitRpmOrder.id]: 0,
  [moduleTypes.InitialCoachingCall.id]: 0,
  [moduleTypes.MonthlyWellnessVisitAC.id]: 0,
  [moduleTypes.CGMAssessment.id]: 0,
  [moduleTypes.CGMQualificationExistingMembers.id]: 0,
  [moduleTypes.MNTNote.id]: 0,
  [moduleTypes.InformedConsentNote.id]: 0,
  [moduleTypes.CareCoordination.id]: 0,
  [moduleTypes.BiannualVisit.id]: 0,
  [moduleTypes.ChartReview.id]: 0,
  [moduleTypes.PerryHealthAssessment.id]: 0,
  [moduleTypes.CoachIntroduction.id]: 0,
  [moduleTypes.PerryMotivationQuestionnaire.id]: 0,
  [moduleTypes.PHQ9GAD7Assessment.id]: 0,
  [moduleTypes.CaseWorkAssessment.id]: 0,
  [moduleTypes.CaseWorkProgressNote.id]: 0,
  [moduleTypes.MFARenewalRequest.id]: 0,
  [moduleTypes.InsulinPumpAssessment.id]: 0,
  [moduleTypes.CognitiveClinicalInterview.id]: 0,
  [moduleTypes.MemoryImpairmentScreen.id]: 0,
  [moduleTypes.ProviderEvaluationOfCognitiveScreening.id]: 0,
  [moduleTypes.MoCABlind.id]: 0,
  [moduleTypes.MindyScreeningResult.id]: 0,
  [moduleTypes.CloseCognitiveAccount.id]: 0,
  [moduleTypes.MindyZBI22Assessment.id]: 0,
  [moduleTypes.MindyPRO10Assessment.id]: 0,
  [moduleTypes.NeurologyEvaluation.id]: 0,
  [moduleTypes.FAST.id]: 0,
  [moduleTypes.CarePlan.id]: 0,
  [moduleTypes.GUIDEFirstCall.id]: 1,
  [moduleTypes.GUIDEIntake.id]: 0,
  [moduleTypes.CrisisResponse.id]: 0,
  [moduleTypes.CognitiveCareIntake.id]: 0,
};
